import { Box, Grid, GridSize, Paper, Typography } from "@mui/material";
import React from "react";
import ConnectedItemDetailConfigurationViewSectionHoc, {
  ItemConfigurationDetail,
} from "./ItemDetailConfigurationViewSection";
import pageStyles from "./../../pages/pageStyles";
import SectionReadForbidden from "../sectionAccess/SectionReadForbidden";

export interface ItemsConfigurationDetail {
  sectionName: string;
  itemsData?: ItemConfigurationDetail[];
  isColumn?: boolean;
  lastItem?: boolean;
  col?: GridSize;
  isRestricted?: boolean;
}

const ItemsDetailConfigurationViewSection = (
  props: ItemsConfigurationDetail
) => {
  const {
    sectionName,
    itemsData,
    isColumn,
    lastItem = false,
    col,
    isRestricted,
  } = props;
  const column = col && typeof col === "number" ? Math.ceil(12 / col) : 12;
  const classes = pageStyles();

  return (
    <Paper
      elevation={0}
      className={classes.sectionWrapper}
      style={{ marginBottom: lastItem ? "0" : "50px" }}
    >
      <Grid
        container
        className={classes.sectionContentWrapper}
        style={{ padding: 0 }}
      >
        <Grid item xs={12} className={classes.sectionHeading}>
          <Typography
            variant="h5"
            display="block"
            className={classes.sectionHeadingTitle}
          >
            {sectionName}
          </Typography>
        </Grid>
        <Grid container spacing={2} className={classes.p15}>
          {!isRestricted ? (
            <>
              {itemsData?.length
                ? itemsData?.map((item, idx) => (
                    <Grid key={idx} item xs={12} md={column as GridSize}>
                      <ConnectedItemDetailConfigurationViewSectionHoc
                        itemData={item.itemData}
                        additionalData={item.additionalData}
                        sectionName={item.sectionName || ""}
                        isChild
                        isColumn={isColumn}
                        isRTL={item.isRTL}
                        bin={item.bin}
                      />
                    </Grid>
                  ))
                : "No Data"}
            </>
          ) : (
            <SectionReadForbidden />
          )}
        </Grid>
      </Grid>
    </Paper>
  );
};

export default ItemsDetailConfigurationViewSection;
